/** Required fields: [host, start, title, type] */
export const selectTitle = ({details}) => details.title.trim();
export const selectHost = ({details}) => details.host;

/** Optional fields: [co-host, end] */
export const selectCohostName = ({details}) => details.cohost.name;
export const selectCohostEmail = ({details}) => details.cohost.email;

export const eventIsPremium = ({details}) => details.isPremium;
export const eventInEditMode = ({details}) => details?.inEditMode;
export const eventInUpsellMode = ({details}) => details.isUpsellMode;

export const selectIsGiphyFeatureSwitchEnabled = ({details}) =>
  details?.isGiphyFeatureSwitchEnabled;
